import moment from 'moment';
import ProfileEducationForm from '@/components/Forms/ProfileEducationForm';
import { DATE_REQUEST } from '@/helpers/common';
import { useUpdateEducation } from '@/query/queries/user/useUpdateEducation';
import { useCreateEducation } from '@/query/queries/user/useCreateEducation';
import { useDeleteEducation } from '@/query/queries/user/useDeleteEducation';

const ProfileEducationModal = ({ onClose, education }) => {
  const { mutateAsync: updateEducation } = useUpdateEducation();
  const { mutateAsync: createEducation } = useCreateEducation();
  const { mutateAsync: deleteEducation } = useDeleteEducation();

  const onSubmit = async values => {
    try {
      const payload = {
        college: values.college,
        degree: values.degree,
        start_date: moment(values.start_date).format(DATE_REQUEST),
        end_date: values.end_date ? moment(values.end_date).format(DATE_REQUEST) : null,
        is_studying: !values.end_date,
      };

      const res = education
        ? await updateEducation({ id: education.id, payload })
        : await createEducation(payload);
      res && onClose();
    } catch (e) {
      console.error(e.message);
    }
  };

  const onRemove = async () => {
    try {
      if (education) {
        const res = await deleteEducation({ educations: [education.id] });
        res && onClose();
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  return (
    <ProfileEducationForm
      education={education}
      onSubmit={onSubmit}
      onRemove={onRemove}
      onCancel={onClose}
    />
  );
};

export default ProfileEducationModal;
